export default "__VITE_ASSET__TsSysvIb__"